const FUEL_STOP_MODAL_OPEN_CLASS = "fuel-stop-modal-open";

export const lockFuelStopModalBackground = (): (() => void) => {
  document.documentElement.classList.add(FUEL_STOP_MODAL_OPEN_CLASS);
  document.body.classList.add(FUEL_STOP_MODAL_OPEN_CLASS);

  return () => {
    document.documentElement.classList.remove(FUEL_STOP_MODAL_OPEN_CLASS);
    document.body.classList.remove(FUEL_STOP_MODAL_OPEN_CLASS);
  };
};
